import { API_EXTERNAL_AUTHENTICATION_PREFIX } from "config/api-consts";
import { BASE_API_URL } from "config/consts";
import { httpConfig } from "config/http";
import { kebabCase } from "lodash";
import { AppUser } from "models/AppUser";
import { Repository } from "react3l-common";
import { Observable } from "rxjs";
import nameof from "ts-nameof.macro";

export type KeyType = string | number;

export class ExternalAuthenticationRepository extends Repository {
  constructor() {
    super(httpConfig);
    this.baseURL = new URL(
      API_EXTERNAL_AUTHENTICATION_PREFIX,
      BASE_API_URL
    ).href;
  }

  public getUserInfo = (): Observable<AppUser> => {
    return this.http
      .post<AppUser>(kebabCase(nameof(this.getUserInfo)))
      .pipe(Repository.responseMapToModel<AppUser>(AppUser));
  };

  public getEndpoint = (uri: string): Observable<String> => {
    return this.http
      .post<String>(kebabCase(nameof(this.getEndpoint)), undefined, {
        params: {
          redirectUri: uri,
        },
      })
      .pipe(Repository.responseDataMapper<String>());
  };

  public login = (
    authorizationCode: string,
    redirectUri: string
  ): Observable<AppUser> => {
    return this.http
      .post<AppUser>(kebabCase(nameof(this.login)), {
        authorizationCode,
        redirectUri,
      })
      .pipe(Repository.responseMapToModel<AppUser>(AppUser));
  };

  public logout = (): Observable<boolean> => {
    return this.http
      .get<boolean>(kebabCase(nameof(this.logout)))
      .pipe(Repository.responseDataMapper<boolean>());
  };
}

export const externalAuthenticationRepository =
  new ExternalAuthenticationRepository();
